







































































































































































import { Component, Prop } from 'vue-property-decorator';
import { Player } from '@bookings/interfaces/multiplayer-booking';
import AbstractField from '@shared/components/forms/inputs/abstract-field/abstract-field';
import { mixins } from 'vue-class-component';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcDisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import { BookingMultiplayerFields } from '@/config/bookings';
import Avatar from 'vue-avatar';
import ToolsHelper from '@core/services/tools.helper';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHandshake, faUser } from '@fortawesome/free-solid-svg-icons';

library.add(faUser, faHandshake);

@Component({
  name: 'bpc-multiplayer-booking-player-card',
  components: {
    BpcEntitySelect,
    BpcDisplayFieldBadge,
    Avatar,
  },
})
export default class MultiplayerBookingPlayerCard extends mixins(AbstractField) {
  @Prop(Object) readonly value: Player;
  @Prop({ type: Boolean, default: false }) readonly allowGuest: boolean;

  get model(): Player {
    return this.value;
  }

  set model(value: Player) {
    this.$emit('input', value);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, this.model);
      });
    }
  }

  get fieldsConfig() {
    return BookingMultiplayerFields;
  }

  get formattedPrice() {
    return this.model.paid_with_subscription
      ? `${this.model.credit_price} ${this.$t('tools.credit_consumption.number_of_credits.label')}`
      : ToolsHelper.formatPrice(this.model.price);
  }

  get paymentMethodDescription() {
    const PAYMENT_TYPES = {
      paid_with_subscription: 'bookings.booking_events.player_payment_type.subscription',
      paid_by_guarantee: 'bookings.booking_events.player_payment_type.guarantee',
      paid_with_stripe: 'bookings.booking_events.player_payment_type.stripe',
    };

    if (this.model.paid_with_subscription) {
      return this.$t(PAYMENT_TYPES.paid_with_subscription);
    }

    if (this.model.paid_by_guarantee) {
      return this.$t(PAYMENT_TYPES.paid_by_guarantee);
    }

    if (this.model.paid_with) {
      return `${this.$t(PAYMENT_TYPES.paid_with_stripe)} ${this.model.paid_with}`;
    }

    return null;
  }

  avatar(value) {
    if (value instanceof Array) return value[0].url;
    else if (value instanceof Object) return value.url;
    else return null;
  }

  onAddGuest() {
    this.model.type = 'guest';
    this.model.contact = null;
    this.model.contact_id = null;
  }

  onAddMember() {
    this.model.type = 'member';
    this.model.contact = null;
    this.model.contact_id = null;
  }

  resetModel() {
    this.model.type = null;
    this.model.contact = null;
    this.model.status = null;
    this.model.contact_id = null;
  }
}
